import { AuthGuard } from '../_guards/auth.guard';
import { ReceiptsList } from './receipts-list.cmp'; 
import { Routes } from '@angular/router'; 

export const ReceiptsRoutes: Routes = [
    { canActivate: [AuthGuard], path: 'receipts', component: ReceiptsList, data: {  roles: "receipts",  title: 'קבלות' } }, 
 
]; 